export default __webpack_public_path__ + "static/media/highest.c52d39d0.jpg";